import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';
import React from "react";
import { ColumnContainer } from "utils/columnsStyle";
import { useDispatch } from "react-redux";
import { COVERAGES_ASSIGN_CONFIG, COVERAGES_ASSIGN_PHRASE } from "./config";
import { editAssignationMode, setSelectedAssignation, deleteAssignationMode } from "redux/actions/coveragesAssign/coveragesAssignActions";
import RegularButton from "components/CustomButtons/Button";
import { blue, red } from "@mui/material/colors";

export const columns = [
    {
        Header: "Fecha",
        accessor: "date",
        filterable: true,
        filterMethod: (filter, row) => String(row.date)?.toLowerCase()?.includes(filter.value.toLowerCase()),
        Cell: props => props?.value || null,
    },
    {
        Header: () => <span>{COVERAGES_ASSIGN_CONFIG.stationName.label}</span>,
        accessor: COVERAGES_ASSIGN_CONFIG.stationName.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COVERAGES_ASSIGN_CONFIG.stationName.key]
                ? row[COVERAGES_ASSIGN_CONFIG.stationName.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>{COVERAGES_ASSIGN_CONFIG.coverageName.label}</span>,
        accessor: COVERAGES_ASSIGN_CONFIG.coverageName.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COVERAGES_ASSIGN_CONFIG.coverageName.key]
                ? row[COVERAGES_ASSIGN_CONFIG.coverageName.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>{COVERAGES_ASSIGN_CONFIG.unitName.label}</span>,
        accessor: COVERAGES_ASSIGN_CONFIG.unitName.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COVERAGES_ASSIGN_CONFIG.unitName.key]
                ? row[COVERAGES_ASSIGN_CONFIG.unitName.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>{COVERAGES_ASSIGN_CONFIG.statusName.label}</span>,
        accessor: COVERAGES_ASSIGN_CONFIG.statusName.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COVERAGES_ASSIGN_CONFIG.statusName.key]
                ? row[COVERAGES_ASSIGN_CONFIG.statusName.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>Acciones</span>,
        filterable: false,
        sortable: false,
        Cell: ({ original }) => {
            const dispatch = useDispatch();
            const openEdit = () => {
                original.modal();
                dispatch(editAssignationMode());
                dispatch(setSelectedAssignation(original));
            };

            const openDelete = () => {
                original.deleteModal(true);
                dispatch(deleteAssignationMode());
                dispatch(setSelectedAssignation(original));
            }

            return (
                <ColumnContainer>
                    <RegularButton
                        tooltip={COVERAGES_ASSIGN_PHRASE.page.table.actions.delete}
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={openDelete}
                    >
                        <DeleteIcon style={{ color: red[500] }} />
                    </RegularButton>
                    <RegularButton
                        tooltip={COVERAGES_ASSIGN_PHRASE.page.table.actions.edit}
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={openEdit}
                    >
                        <EditIcon style={{ color: blue[800] }} />
                    </RegularButton>
                </ColumnContainer>
            );
        },
    },
];
